export interface IReliableLabel {
  /** Заголовок лейбла **/
  title: string;
  /** Тип надежности ЖК **/
  type: EType;
}
export enum EType {
  /** Проблемный ЖК **/
  'Problem' = 'problem',
  /** Надежный ЖК **/
  'Reliable' = 'reliable',
}
